import { Record } from 'immutable';
import { LocaleService } from '@sm360/widget-commons-core-services';

const EngineRecord = Record({
    selectionCode: '0L-0C-0',
    code: '',
    fuelTypeCode: 0,
    cylinders: 0,
    displacement: 0,
    isTurbo: false,
    hp: 0,
    hpRpm: 0,
    torque: 0,
    torqueRpm: 0,
});

class Engine extends EngineRecord {
    getSelectionCode() {
        return this.get('selectionCode');
    }

    getSizeSpecifications() {
        return this.get('isTurbo')
            ? LocaleService.t('engine.sizeTurbo', {
                  displacement: this.get('displacement'),
                  cylinders: this.get('cylinders'),
              })
            : LocaleService.t('engine.size', {
                  displacement: this.get('displacement'),
                  cylinders: this.get('cylinders'),
              });
    }

    getPowerSpecifications() {
        if (this.hp === 0 || this.torque === 0) {
            return '';
        }
        return LocaleService.t('engine.power', { hp: this.get('hp'), torque: this.get('torque') });
    }
}

export default Engine;
